import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getHistoryYears} from '../../services/getHistoryYears';
import {UseGetHistoryYearsQueryParams} from './types';

export const useGetHistoryYearsQuery = ({isShowCurrentYear}: UseGetHistoryYearsQueryParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.HISTORY_YEARS, isShowCurrentYear],
		queryFn: async ({signal}) => getHistoryYears({isShowCurrentYear, signal}),
		retry: 2,
	});
